// Interprétation des résultats en langage simple.
import { duration } from './format';

export interface Usage {
  label: string;
  ok: boolean;
  detail: string;
}

export interface Measures {
  down?: number | null;
  up?: number | null;
  latency?: number | null;
  jitter?: number | null;
  grade?: string | null;
}

const gradeRank = (g?: string | null) => 'ABCDEF'.indexOf(g ?? '?');

export function interpret(m: Measures): Usage[] {
  const down = m.down ?? 0;
  const up = m.up ?? 0;
  const lat = m.latency ?? 999;
  const jit = m.jitter ?? 0;
  const g = gradeRank(m.grade);
  const streams4k = Math.floor(down / 25);
  const out: Usage[] = [
    {
      label: 'Visioconférence en HD',
      ok: down >= 4 && up >= 3 && lat <= 100,
      detail: up >= 3 ? 'Image et son fluides dans les deux sens.' : 'Le débit montant est trop faible pour envoyer une image HD.',
    },
    {
      label: 'Streaming vidéo 4K',
      ok: streams4k >= 1,
      detail: streams4k >= 1 ? `Jusqu'à ${streams4k} écran${streams4k > 1 ? 's' : ''} en 4K simultanément.` : 'Préférez la HD (5 Mbit/s par écran).',
    },
    {
      label: 'Jeu en ligne',
      ok: lat <= 40 && jit <= 10 && g >= 0 && g <= 2,
      detail:
        g > 2
          ? 'La latence augmente fortement quand la ligne est chargée : risque de décalage si quelqu’un télécharge en même temps.'
          : lat <= 40
            ? 'Latence faible et stable.'
            : 'Latence élevée pour les jeux compétitifs.',
    },
    {
      label: 'Télétravail et envoi de fichiers',
      ok: up >= 10,
      detail: up > 0 ? `Un fichier de 1 Go part en ${duration((8000 / up) * 1.05)}.` : '—',
    },
    {
      label: 'Téléchargement d’un jeu de 50 Go',
      ok: down >= 100,
      detail: down > 0 ? `Environ ${duration((400000 / down) * 1.05)}.` : '—',
    },
  ];
  return out;
}

export const gradeText: Record<string, string> = {
  A: 'Excellente : la latence reste stable même quand la ligne est saturée.',
  B: 'Bonne : légère hausse de la latence sous charge.',
  C: 'Correcte : la latence augmente sensiblement sous charge.',
  D: 'Médiocre : appels et jeux perturbés pendant les téléchargements.',
  E: 'Mauvaise : forte saturation des files d’attente (bufferbloat).',
  F: 'Très mauvaise : la connexion devient inutilisable sous charge.',
  '?': 'Non mesurée.',
};
